import type { AppStore } from "@/store/AppStore";
import { AiToolkitNoteNotFoundError } from "@/modules/ai-toolkit/errors";
import type { NavigateToNoteInput, NavigateToNoteOutput } from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  navigateToNoteInputSchema,
  navigateToNoteOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";

export const navigateToNote = async ({
  store,
  input,
}: {
  store: AppStore;
  input: NavigateToNoteInput;
}): Promise<NavigateToNoteOutput> => {
  const note = await store.notes.getAsync(input.noteId);

  if (!note?.isAvailable) {
    throw new AiToolkitNoteNotFoundError({ noteId: input.noteId });
  }

  store.navigation.goToNote({
    noteId: input.noteId,
    highlightText: input.highlightText ?? null,
    openInSameTab: input.openInSameTab ?? true,
  });

  return {
    navigated: true,
    noteId: input.noteId,
  };
};

export const navigateToNoteTool: AiToolkitToolDefinition<
  AiToolkitToolName.NavigateToNote,
  NavigateToNoteInput,
  NavigateToNoteOutput
> = {
  name: AiToolkitToolName.NavigateToNote,
  inputSchema: navigateToNoteInputSchema,
  outputSchema: navigateToNoteOutputSchema,
  strict: true,
  execute: navigateToNote,
};
